import { TileService } from '../lead-dashboard/selected-leads-view/selected-leads-map/tile.service';
import VectorSource from 'ol/source/Vector';
import TileLayer from 'ol/layer/Tile';
import { ImageTile } from 'ol/source';
import { createXYZ } from 'ol/tilegrid';
import Map from 'ol/Map';
import VectorLayer from 'ol/layer/Vector';
import View from 'ol/View';
import { fromLonLat } from 'ol/proj';
import { TranslateService } from '@ngx-translate/core';

export function initMap(
  vectorSources: VectorSource[],
  tileService: TileService,
  mapHtmlElementId: string,
  translateService: TranslateService,
) {
  const loadImage: (
    z: number,
    x: number,
    y: number,
  ) => Promise<HTMLImageElement> = (z: number, x: number, y: number) => {
    return new Promise((resolve, reject) => {
      tileService.getTile(z, x, y).subscribe((blob) => {
        const reader = new FileReader();
        const img = new Image();
        reader.onload = () => {
          img.src = reader.result as string;
          resolve(img);
        };
        reader.onerror = (err) => reject(err);
        img.onerror = (err) => reject(err);
        reader.readAsDataURL(blob);
      });
    });
  };

  const tileLayer = new TileLayer({
    source: new ImageTile({
      tileGrid: createXYZ({
        tileSize: 256,
        minZoom: 0,
        maxZoom: 19,
      }),
      loader: async (z, x, y) => await loadImage(z, x, y),
      attributions:
        '&copy; <a href="https://cloud.google.com/maps-platform/terms?hl=en">Google Maps</a>',
    }),
  });

  const subscription = translateService.onLangChange.subscribe(() =>
    tileLayer.getSource()?.refresh(),
  );

  return {
    subscription: subscription,
    map: new Map({
      target: mapHtmlElementId,
      layers: [
        tileLayer,
        ...vectorSources.map(
          (vectorSource) => new VectorLayer({ source: vectorSource }),
        ),
      ],
      view: new View({
        center: fromLonLat([11.5924, 48.1306]),
        zoom: 15,
      }),
    }),
  };
}
